import './Header.css'
import React from "react";
import circles from '../assets/images/circles.png'
import StoryFeature from './components/StoryFeature.js';
import butterflyLogo from '../assets/images/butterflyLogo.png'

function Header(props) {
    return (
        <div>
            <h1 className="headerText"> cerasus </h1>
            <h2 className="headerBrandSubText"> creative studios</h2>
            <img className="butterflyLogo" src={butterflyLogo} alt="cerasus logo - a black and purple chrome butterfly" />
            <img className="headerCircles" src={circles} alt="three overlapping circles" />
            {/* <p className="headerBodyText"> creative studio producing fun typefaces, custom graphics, and more</p> */}
            <div className="graphPositioningHeader">
                <StoryFeature />
            </div>
        </div>

    )

}

export default Header;